import jQuery from 'jquery';
import rpBreakpoints, { breakpointCodes } from 'rp-mq-breakpoints';

const preopenAccordionNames = [
    'RC-accordion_byMeeting',
    'RC-accordion_cardTab',
    'RC-accordion_proTab',
    'RC-accordion_glanceTab',
    'RC-accordion_oddsTab'
];

const scrollAccordionNames = [
    'RC-accordion_byMeeting'
];

function shouldPreopenAccordion(accordionName) {
    return preopenAccordionNames.includes(accordionName);
}

function shouldScrollToAccordion(accordionName) {
    const isSmallBreakpoint = [breakpointCodes.EXTRA_NARROW, breakpointCodes.NARROW]
        .includes(rpBreakpoints.current().code);

    return scrollAccordionNames.includes(accordionName) && isSmallBreakpoint;
}

function scrollTo(selector) {
    const $window = jQuery(window);
    const wrapper = jQuery(selector);

    if (wrapper.length === 1) {
        $window.scrollTop(wrapper.offset().top);
    }
}

export default function preopenAccordions(accordions, type) {
    const selector = `[data-accordion-row="${type}"]`;

    jQuery.each(accordions, (accordionName, accordion) => {
        if (shouldPreopenAccordion(accordionName)) {
            accordion.expandRow('', selector);
        }
        if (shouldScrollToAccordion(accordionName)) {
            scrollTo(selector);
        }
    });
}



// WEBPACK FOOTER //
// ./lib/js/modules/preopenAccordions.js